export const ActivFitnessTheme = {
  name: 'Active Fitness Theme',
  themeId: 'activFitness',
  colors: {
    brand: {
      primary: {
        100: '#E2001A'
      },
      secondary: {
        100: '#D10018'
      },
      accent: {
        100: '#E2001A'
      },
      background: {
        100: '#F7F7F7'
      },
      text: {
        100: '#261B11'
      }
    },
    tints: {
      gray: {
        10: '#f1f1f1',
        25: '#e5e5e5',
        40: '#b2b2b2',
        45: '#969696',
        60: '#666666',
        75: '#4d4d4d',
        90: '#333333',
        100: '#000000'
      }
    }
  },
  backgrounds: {
    tile: '#E2001A'
  },
  fonts: {
    families: {
      text: '"Source Sans Pro", "Helvetica", arial, sans-serif'
    },
    sizes: {
      text: {
        xsmall: '15px',
        small: '17px'
      },
      heading: {
        small: '20px'
      }
    }
  }
};